import { render, staticRenderFns } from "./AccumulationsTabs.vue?vue&type=template&id=0dbe4f1d"
import script from "./AccumulationsTabs.vue?vue&type=script&lang=ts"
export * from "./AccumulationsTabs.vue?vue&type=script&lang=ts"
import style0 from "./AccumulationsTabs.vue?vue&type=style&index=0&id=0dbe4f1d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports